const en = {
  // Stores list
  storesTitle: "Your stores",
  storesDescription: "Choose a store to manage, or create a new one.",
  createStore: "Create store",
  upgradeToAddStores: "Upgrade to add stores",
  verifyEmailNotice: "Please verify your email address — we sent a link to {email}.",
  resend: "Resend",
  firstStoreTitle: "Create your first store",
  firstStoreDescription: "It takes a couple of minutes. You can keep the store private until you’re ready to publish.",
  createAStore: "Create a store",
  currentPlan: "Current plan",
  managePlan: "Manage plan",

  // New store
  newStoreMeta: "Create a store",
  welcomeTitle: "Welcome! Let’s set up your store",
  newStoreTitle: "Create a new store",
  newStoreDescription: "Step 1 of setup — the basics. Next you’ll add products, choose how to get paid and publish when ready.",
  storeLimitTitle: "Store limit reached",
  storeLimitBody: "Your {plan} plan allows {count} stores.",
  storeLimitBody_one: "Your {plan} plan allows {count} store.",
  seePlans: "See plans",
  platformSuffixPath: " (at {url}/s/…)",
  biz_general: "General retail",
  biz_fashion: "Fashion & apparel",
  biz_electronics: "Electronics",
  biz_beauty: "Beauty & cosmetics",
  biz_home: "Home & furniture",
  biz_food: "Food & specialty goods",
  biz_digital: "Digital products",
  biz_services: "Services",
  fieldStoreName: "Store name",
  changeLaterHint: "You can change this later.",
  fieldStoreAddress: "Store address",
  slugTaken: "That address is taken or reserved.",
  slugHint: "Your free address: {address}. You can connect your own domain later.",
  slugPlaceholder: "your-store",
  fieldBusinessType: "What will you sell?",
  fieldStoreLanguage: "Store language",
  fieldCountry: "Country",
  fieldStoreCurrency: "Store currency",
  currencyHint: "Prices and orders use this currency. It can’t change after your first order.",
  fieldTimezone: "Time zone",
  fieldTheme: "Starting theme",
  themeHint: "Leave on Recommended to match your business type.",
  themeRecommended: "Recommended",
  themePaidPlans: " (paid plans)",
  creatingStore: "Creating your store…",

  // Account & security
  accountDescription: "Manage your profile, sign-in security and notifications.",
  profile: "Profile",
  emailAddress: "Email address",
  verified: "Verified",
  notVerified: "Not verified",
  verifiedOn: "Verified on {date}.",
  verifyPrompt: "Verify your address so you can recover your account and receive billing notices. Check your inbox for the link we sent.",
  resendVerification: "Resend verification email",
  sending: "Sending…",
  changePassword: "Change password",
  changePasswordDescription: "Changing your password signs you out on all other devices.",
  activeSessions: "Active sessions",
  activeSessionsDescription: "Devices currently signed in to your account. Sign out any you don’t recognise, then change your password.",
  signOutOthersTitle: "Sign out all other sessions?",
  signOutOthersBody: "Every other device will need to sign in again.",
  signOutOthersConfirm: "Sign out others",
  signOutAllOthers: "Sign out all others",
  colDevice: "Device",
  colLocation: "Location (IP)",
  colSignedIn: "Signed in",
  colLastActive: "Last active",
  thisDevice: "This device",
  sessionSignOut: "Sign out",
  signingOut: "Signing out…",
  notifPrefs: "Notification preferences",
  notifPrefsDescription: "Choose which store notifications you receive in the app. Billing, security and support messages are always sent.",
  closeAccount: "Close account",
  closeAccountDescription: "Ask our team to close your Storelancer account.",
  emailHint: "Contact support to change the email address on your account.",
  saveProfile: "Save profile",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  passwordHint: "At least 10 characters with a letter and a number.",
  changing: "Changing…",
  savePreferences: "Save preferences",
  closureReason: "Why are you leaving?",
  closureConfirm: "I understand this sends a closure request to the Storelancer team.",
  closureHint: "Nothing is deleted automatically. We’ll confirm with you first and explain what happens to your stores, orders and subscription.",
  requestClosure: "Request account closure",
  viewRequest: "View your request",
  notifGroup_orders: "Orders",
  notifGroup_catalog: "Catalog",
  notifGroup_payments: "Payments",
  notifGroup_domains: "Domains",
  notif_orders_new: "New order placed",
  notif_orders_paid: "Order payment confirmed",
  notif_orders_refunded: "Order refunded",
  notif_orders_return_requested: "Return requested",
  notif_inventory_low_stock: "Low stock",
  notif_payments_failed: "Payment failed",
  notif_payments_dispute: "Dispute or chargeback opened",
  notif_payments_connection_problem: "Payment connection needs attention",
  notif_payments_checkout_error: "Checkout couldn’t start a payment",
  notif_payments_mismatch: "Payment amount mismatch",
  notif_domains_verified: "Domain verified",
  notif_domains_failed: "Domain verification failed",
  profileSaved: "Profile saved.",
  prefsSaved: "Notification preferences saved.",
  sessionEnded: "Your session has ended. Sign in again.",
  newPasswordsDontMatch: "The new passwords don’t match.",
  passwordsDontMatch: "Passwords don’t match",
  chooseStrongerPassword: "Choose a stronger password",
  passwordChanged: "Password changed. You’ve been signed out everywhere else.",
  sessionSignedOut: "Session signed out.",
  otherSessionsSignedOut: "All other sessions were signed out.",
  verificationSent: "Verification email sent to {email}.",
  confirmClosure: "Please confirm you want to request account closure.",
  required: "Required",
  closureSent: "Request sent as support ticket #{number}. Our team will contact you before anything is deleted.",

  // Notifications
  notificationsDescription: "Updates about your stores, billing and support requests.",
  markAllRead: "Mark all as read",
  unread: "Unread",
  noUnread: "No unread notifications",
  noNotifications: "No notifications yet",
  notificationsEmpty: "We’ll let you know about new orders, payment issues, domain checks and replies from support.",
  unreadSr: " (unread)",
  markRead: "Mark read",
  notifKind_orders: "Orders",
  notifKind_inventory: "Inventory",
  notifKind_payments: "Payments",
  notifKind_domains: "Domains",
  notifKind_billing: "Billing",
  notifKind_support: "Support",
  notifKind_security: "Security",
  notifKind_account: "Account",
  notifKind_team: "Team",
  notifKind_store: "Store",
  notifKind_system: "System",
  allCaughtUp: "All caught up.",
  unknownNotification: "Unknown notification",

  // Billing
  billingDescription: "Your Storelancer subscription. This is separate from the payments your customers make in your stores, which go to your own payment provider.",
  checkoutDoneTitle: "Thanks — checkout completed",
  checkoutDoneBody: "Your plan updates as soon as our billing provider confirms the payment. This usually takes a few seconds; refresh the page if it hasn’t changed yet.",
  planUpdated: "Your plan was updated. The details below reflect the change.",
  checkoutCancelled: "Checkout was cancelled. Your plan hasn’t changed.",
  billingUnavailableTitle: "Online payment for paid plans isn’t available yet",
  billingUnavailableBody: "Platform billing hasn’t been set up by the operator, so paid plans can’t be purchased here right now. You can still switch to a free plan.",
  contactSupportToUpgrade: "{link} to upgrade.",
  contactSupport: "Contact support",
  free: "Free",
  pricePerMonth: "{price} / month",
  pricePerYear: "{price} / year",
  perMonthSuffix: " / month",
  orPerYear: "or {price} / year",
  billing: "Billing",
  billedYearly: "Billed yearly",
  billedMonthly: "Billed monthly",
  noPaymentNeeded: "No payment needed",
  assignedByPlatform: "Assigned by Storelancer (no card on file)",
  trialEnds: "Trial ends",
  endsOn: "Ends on",
  renewsOn: "Renews on",
  movingToPlan: "You’ll move to {plan} at the end of the current period.",
  subscriptionEnding: "Your subscription is set to end at the close of the current period.",
  dataKept: "Your stores and data are kept either way.",
  pastDue: "Your last subscription payment failed. Update your payment method from the latest invoice to keep your plan.",
  cancelTitle: "Cancel your subscription?",
  cancelBody: "You keep your current plan until the end of the billing period, then move to the free plan. Nothing is deleted — if you’re above the free plan’s limits you just can’t add more.",
  cancelSubscription: "Cancel subscription",
  planEnding: "Your plan will end at the close of the current billing period. Your data is kept.",
  usage: "Usage",
  storesYouOwn: "Stores you own",
  perStoreUsage: "Per-store usage is shown in each store’s settings.",
  changePlan: "Change plan",
  changePlanDescription: "Lowering your plan never deletes stores, products or orders. If you’re above a limit, you keep what you have but can’t add more until you’re back within it.",
  switchToTitle: "Switch to {plan}?",
  switchBodyPaid: "Your paid subscription ends at the close of the current billing period, then you move to this plan. Nothing is deleted.",
  switchBodyFree: "The change applies immediately. Nothing is deleted, but you can’t add more than this plan allows.",
  switchTo: "Switch to {plan}",
  startingCheckout: "Starting checkout…",
  startTrial: "Start {days}-day trial",
  upgradeMonthly: "Upgrade monthly",
  yearly: "Yearly",
  invoices: "Invoices",
  invoicesDescription: "Invoices for your Storelancer subscription.",
  noInvoices: "No invoices yet",
  noInvoicesDescription: "Invoices appear here after your first paid subscription payment.",
  colInvoice: "Invoice",
  colPeriod: "Period",
  colLink: "Link",
  invoiceSr: " invoice {number}",

  // Support
  supportDescription: "Ask the Storelancer team for help. We reply here and by email.",
  yourRequests: "Your requests",
  noRequests: "No support requests yet",
  noRequestsDescription: "Before writing to us, the {link} may already have the answer.",
  setupGuides: "setup guides",
  colRequest: "Request",
  colCategory: "Category",
  awaitingReply: "Awaiting your reply",
  newRequest: "New request",
  cat_general: "General question",
  cat_billing: "Plan & billing",
  cat_payments: "Payments & payouts",
  cat_domains: "Domains",
  cat_technical: "Technical problem",
  cat_account: "Account & sign-in",
  fieldSubject: "Subject",
  fieldCategory: "Category",
  fieldStore: "Store",
  notAboutStore: "Not about a specific store",
  fieldHowCanWeHelp: "How can we help?",
  ticketBodyHint: "Include what you expected and what happened. Never share passwords or API keys.",
  sendToSupport: "Send to support",
  fieldYourReply: "Your reply",
  sendReply: "Send reply",
  subjectLength: "Use 3–150 characters",
  bodyLength: "Describe the issue in at least 10 characters",
  checkFields: "Please check the highlighted fields.",
  writeMessageFirst: "Write a message first.",
  replySent: "Reply sent.",
  ticketMeta: "Support request",
  ticketSummary: "Request #{number} · {category} · opened {date}",
  requestSent: "Your request was sent. We’ll reply here and email you at {email}.",
  conversation: "Conversation",
  supportTeam: "Storelancer support",
  you: "You",
  requestClosed: "This request is closed",
  reply: "Reply",
  replyReopens: "Replying reopens the request.",

  // Invitations
  inviteMeta: "Store invitation",
  homeLink: "Storelancer home",
  inviteUnavailable: "Invitation not available",
  inviteUnavailableDescription: "This invitation link is invalid, has expired, or was already used. Ask the store owner to send a new invitation.",
  goToYourDashboard: "Go to your dashboard",
  invitedEyebrow: "You’ve been invited",
  joinStore: "Join {store}",
  invitedAs: "You’re invited to help manage this store as",
  invitationFor: "Invitation for",
  expires: "Expires",
  signInToAcceptHelp: "Sign in with {email} to accept. New to Storelancer? Create an account with that email, then open this invitation link again.",
  signInToAccept: "Sign in to accept",
  differentAccount: "Different account",
  differentAccountBody: "You’re signed in as {current}, but this invitation was sent to {invited}. Sign out and sign in with the invited address to accept.",
  joining: "Joining…",
  acceptInvitation: "Accept invitation",
  notNow: "Not now",
};

export default en;
